import type { Resource } from '../../';
export const product_details_sizeChart: Resource = {"default":"Size Chart"};
